/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_TitleInputs */

const fr_page_title = /** @type {(inputs: Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick Search - Demo`)
};

const en_page_title = /** @type {(inputs: Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick Search - Demo`)
};

/**
* | output |
* | --- |
* | "Quick Search - Demo" |
*
* @param {Page_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const page_title = /** @type {((inputs?: Page_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_page_title(inputs)
	return en_page_title(inputs)
});